import type { IconLibrary } from 'src/components/DynamicIcon/dynamic-icon';
export interface BulkOption {
  iconLibrary?: IconLibrary;
  id?: string | number | boolean;
  value?: string | number | boolean;
  label?: string;
  icon?: string;
  color?: string;
  platformSlaId?: string | null;
  conversationParticipantId?: string;
  entityPartnerId?: number | null;
  conversationAssigneeGroups?: { id?: string | null }[];
  userGroups?: { ruleValues?: { userGroupRuleId?: string | null }[] }[];
}

export function getBulkOptionLabel(option: BulkOption): string {
  return option.label ?? String(option.value ?? option.id ?? '');
}

export function getBulkOptionKey(option: BulkOption): string {
  return String(option.id ?? option.value ?? '');
}

export function getBulkOptionSubmitValue(
  option: BulkOption,
  editorType: string | undefined,
): string {
  if (editorType === 'entity-search') {
    return String(option.id ?? option.value ?? '');
  }
  return String(option.value ?? option.id ?? '');
}

export function getMutationErrorMessage(error: unknown): string {
  if (error instanceof Error && error.message) {
    return error.message;
  }
  return 'Bulk update request failed. Please try again.';
}
